<template>
  <report-tab
    ref="reportTab"
    :search-query="searchQuery"
    :date-range="dateRangeFromSingleDate"
    :selected-status="selectedStatus"
    :selected-delivery-type="selectedDeliveryType"
    :is-active-tab="isActiveTab"
  />
</template>

<script>
import ReportTab from "./ReportTab.vue";

export default {
  name: "OrdersTab",
  components: {
    ReportTab,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    searchQuery: {
      type: String,
      default: "",
    },
    selectedDate: {
      type: String,
      default: () => new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
    },
    selectedStatus: {
      type: Object,
      default: () => ({ id: 0, name: "all" }),
    },
    selectedDeliveryType: {
      type: Object,
      default: () => ({ id: 3, name: "all" }),
    },
    isActiveTab: Boolean,
  },
  computed: {
    dateRangeFromSingleDate() {
      return [this.selectedDate, this.selectedDate];
    },
  },
  methods: {
    reload() {
      if (typeof this.$refs.reportTab?.loadReportData === "function") {
        this.$refs.reportTab.loadReportData();
      }
    },
  },
};
</script>
